import script from "./inventoryLocations.vue?vue&type=script&setup=true&lang=ts"
export * from "./inventoryLocations.vue?vue&type=script&setup=true&lang=ts"

import "./inventoryLocations.vue?vue&type=style&index=0&id=40431f3c&lang=scss"

const __exports__ = script;

export default __exports__